import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import useMetaLayoutContext
  from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import { Tooltip } from 'Components/UI/Tooltip';
import moment from 'moment';

function AccomplishmentLayout({
  classes,
  onRemove,
  index,
  isFutureAccomplishment,
}) {
  const { resource, handleChange } = useMetaLayoutContext();
  const [removing, setRemoving] = React.useState(false);
  const [invalidText, setInvalidText] = React.useState([]);
  React.useEffect(() => {
    if (resource) {
      if (resource.attr('customText')) {
        const regex = '\\[(.*?)\\]';
        const invalidMatches = [...resource.attr('customText').matchAll(regex)];
        const invalidTokens = invalidMatches.map(item => item[0]);
        setInvalidText(invalidTokens);
      }
      if (
        !isFutureAccomplishment
          && (!resource.attr('accomplishedOn')
              || resource.attr('accomplishedOn') === '')
      ) {
        handleChange(
          'accomplishedOn',
          moment().toISOString(),
        );
      }
    }
  }, [resource]);

  return (
    <div className={classes.root}>
      <div className={classes.inputs}>
        <div className={classes.firstRow}>
          <div className={classes.typeInputContainer}>
            <MetaField
              attr="type"
              test="accomplishment-type-input"
            />
          </div>
          <MetaField
            attr="emailText"
            className={classes.customTextInput}
            test="accomplishment-default-text-input"
          />
          <MetaField
            attr="accomplishedOn"
            test="accomplishment-accomplished-on-input"
          />
        </div>
        <MetaField
          attr="customText"
          className={classes.customTextInput}
          inputProps={{
            className: classes.customTextInput,
          }}
          multiline
          test="accomplishment-custom-text-input"
        />
      </div>
      {invalidText.length > 0 && (
        <Tooltip
          title={`This email text has the following template placeholders in it, ${invalidText}, please replace them`}
        >
          <ErrorIcon className={classes.errorIcon} />
        </Tooltip>
      )}
      <div>
        <IconButton
          disabled={removing}
          size="small"
          onClick={() => {
            setRemoving(true);
            onRemove(resource, index).finally(() => setRemoving(false));
          }}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
}

AccomplishmentLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  isFutureAccomplishment: PropTypes.bool,
  index: PropTypes.number.isRequired,
};

AccomplishmentLayout.defaultProps = {
  isFutureAccomplishment: false,
};

export default withStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
    border: `1px solid ${theme.palette.facet.accentGray}`,
    borderRadius: theme.radius.md,
  },
  hidden: {
    display: 'none',
  },
  errorIcon: {
    color: theme.palette.facet.red,
  },
  customTextInput: {
    fontSize: '0.7rem',
    display: 'flex',
    width: '100%',
    marginRight: theme.spacing(1),
  },
  typeInputContainer: {
    display: 'flex',
    width: '30%',
    marginBottom: 'auto',
    marginRight: theme.spacing(1),
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(1),
  },
  firstRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))(AccomplishmentLayout);
